<script setup lang="ts">
import { getTransactionList } from '@/api/modules/home'

definePage({
  name: 'transaction-list',
  meta: {
    title: '劵商成交榜',
  },
})

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)

async function onLoad() {
  try {
    const { status, data } = await getTransactionList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}

const topBg: any = {
  0: '#FDDA38',
  1: '#C5CFDC',
  2: '#BB9E7D',
}
</script>

<template>
  <FmPageLayout navbar back class="fluctuation-page">
    <template #navbar-end>
      <FmIcon name="ri:share-forward-box-line" class="m-l-16px text-22px color-[#fff]" />
    </template>
    <div class="h28px flex items-center justify-between bg-[#FFEFE5] p-l-8px p-r-8px text-11px color-[#3C78FF]">
      <div>今日十大买入/卖出股票，本页数据为估算值</div>
      <div class="flex items-center">
        <span>更新：12/25 16:00</span>
      </div>
    </div>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <vxe-table
        header-row-class-name="table-header"
        :data="list"
      >
        <vxe-column field="broker" title="名称" fixed="left" width="35%">
          <template #default="{ $rowIndex, row }">
            <div class="flex items-center text-15px font-500">
              <div class="line-height22px w-50px rounded-4px text-center text-14px" :style="{ background: topBg[$rowIndex], color: $rowIndex < 3 ? '#fff' : '#333' }">
                {{ $rowIndex < 3 ? 'TOP' : '' }}{{ $rowIndex + 1 }}
              </div>
              <div class="m-l-10px text-13px">
                {{ row.broker }}
              </div>
            </div>
          </template>
        </vxe-column>
        <vxe-column field="amount" title="成交金额" width="25%" :formatter="({ cellValue }) => `${cellValue}亿`" />
        <vxe-column field="netAmount" title="净买卖金额" width="25%">
          <template #default="{ row }">
            <span class="text-15px font-500" :style="{ color: row.netAmount > 0 ? '#E51A2D' : '#22A875' }">
              {{ row.netAmount }}亿
            </span>
          </template>
        </vxe-column>
        <vxe-column field="buyAmount" title="总买入金额" width="25%">
          <template #default="{ row }">
            <div class="text-15px font-500" :style="{ color: row.buyAmount > 0 ? '#E51A2D' : '#22A875' }">
              {{ row.buyAmount }}亿
            </div>
          </template>
        </vxe-column>
        <vxe-column field="sellAmount" title="卖出金额" align="right" width="25%">
          <template #default="{ row }">
            <span class="text-15px font-500" :style="{ color: row.sellAmount > 0 ? '#E51A2D' : '#22A875' }">
              {{ row.sellAmount }}亿
            </span>
          </template>
        </vxe-column>
      </vxe-table>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }

  .active-card {
    color: #fff;
    background-color: #3c78ff;
    border-color: #3c78ff !important;
  }
}
</style>
